import { gql } from '@apollo/client';

/** Home carousel row only — no priceCalendar / calculatedPrice / images. */
export const HOT_LOCATION_CAR_FIELDS = `
  id
  make
  model
  year
  category
  weekdayPrice
  monthlyPrice
  monthlyRentalIsOn
  thumbnailUrl
  isCreated
`;

export const GET_HOT_LOCATIONS = gql`
  query HotLocations {
    hotLocations {
      id
      city
      state
      latitude
      longitude
      index
      amount
      createdAt
      updatedAt
    }
  }
`;

export const GET_MONTHLY_RENTAL_HOT_LOCATION_SECTIONS = gql`
  query MonthlyRentalHotLocationSections($input: HotLocationMonthlySectionsInput) {
    monthlyRentalHotLocationSections(input: $input) {
      hotLocation {
        id
        city
        state
        latitude
        longitude
        index
        amount
      }
      cars {
        ${HOT_LOCATION_CAR_FIELDS}
      }
    }
  }
`;

export const CREATE_HOT_LOCATION = gql`
  mutation CreateHotLocation($input: HotLocationInput!) {
    createHotLocation(input: $input) {
      id
      city
      state
      latitude
      longitude
      index
      amount
    }
  }
`;

export const UPDATE_HOT_LOCATION = gql`
  mutation UpdateHotLocation($input: UpdateHotLocationInput!) {
    updateHotLocation(input: $input) {
      id
      city
      state
      latitude
      longitude
      index
      amount
    }
  }
`;

export const DELETE_HOT_LOCATION = gql`
  mutation DeleteHotLocation($id: ID!) {
    deleteHotLocation(id: $id)
  }
`;

export const REORDER_HOT_LOCATIONS = gql`
  mutation ReorderHotLocations($input: ReorderHotLocationsInput!) {
    reorderHotLocations(input: $input) {
      id
      city
      state
      index
      amount
    }
  }
`;
